import React, { useMemo } from "react";
import styled from "styled-components";
import { globalTheme } from "@clds/component-theme";
import t from "common/i18n";
import { Combobox } from "@cld/combobox";

const SectionBox = styled.section`
	border-bottom: 1px solid ${globalTheme.palette.secondary};
	padding: ${globalTheme.spacing.md};
	label {
		font-weight: bold;
		white-space: nowrap;
		display: block;
		padding-bottom: ${globalTheme.spacing.xs};
		font-size: ${globalTheme.font.size.xs};
	}
	.uw-radio-group li .label {
		text-align: left;
	}
`;
const FormatLabel = styled.div`
	padding-top: ${globalTheme.spacing.sm};
	color: ${globalTheme.palette.secondary};
`;

const sizesToOptions = (asset, source) => {
	return asset.downloadSizes.map((item) => ({
		value: item.name,
		label: asset.isVideo ? `${item.description}` : t(`${source}.purchase.size.${item.name}`),
		size: item.bytes,
		height: item.height
	})).sort((a, b) => (a.height - b.height));
};

export default ({ selectedAsset, selectedFormat, selectAssetFormat, source }) => {
	const items = useMemo(() => sizesToOptions(selectedAsset, source), [selectedAsset, source]);
	const selectedFormatData = selectedAsset.downloadSizes.find((item) => item.name === selectedFormat?.value);
	const [heightInch, widthInch] = [(selectedFormatData?.height / 300).toFixed(2), (selectedFormatData?.width / 300).toFixed(2)];
	return (<SectionBox>
		<label>{t(`${source}.purchase.format`)}</label>
		<Combobox
			size="md"
			isSearchable={false}
			isClearable={false}
			placeholder={t(`${source}.select`)}
			options={items}
			value={selectedFormat}
			onChange={selectAssetFormat} />
		{!!selectedFormat && selectedFormatData && !selectedAsset.isVideo && (
			<FormatLabel>
				{selectedFormatData.height} x {selectedFormatData.width} px ({heightInch} x {widthInch} in.) - 300 dpi - RGB
			</FormatLabel>
		)}
	</SectionBox>);
};
